import { AssetHardwareType } from "TypeGen/Assets/asset-hardware-type";

export const trailerHardwareTypes = [
  { ID: AssetHardwareType.TriStateSamsara, Name: 'Samsara - Tri-State' },
  { ID: AssetHardwareType.LoadOneSamsara, Name: 'Samsara - Load One' },
];

const hiddenTrailerHardwareTypes = [
  AssetHardwareType.TriStateSamsara,
];

export const assignableTrailerHardwareTypes = (currentType: AssetHardwareType | null) =>
  trailerHardwareTypes.filter(x => !hiddenTrailerHardwareTypes.includes(x.ID) || x.ID === currentType);
